import { render } from "./ChoosenVegetable.vue?vue&type=template&id=2157bab2"
import script from "./ChoosenVegetable.vue?vue&type=script&lang=js"
export * from "./ChoosenVegetable.vue?vue&type=script&lang=js"

import "./ChoosenVegetable.vue?vue&type=style&index=0&id=2157bab2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__